<app-share-button></app-share-button>
<div class="row">
    <div class="col-md-8  ScrollStyle-1">
        <div class="card crd p-3">
            <div class="row">
                <div class="col-md-10 col10 mt-2">
                    <h2>Onboarding Process</h2>
                </div>
                <div class="col-md-2 col2"><a href="javascript:void(0)" (click)="openShareOptions()"> <button
                            class="btn share"><img src="./assets/share (5).svg" style="width: 30px;"
                                (click)="menues('share-button')" alt=""> </button> </a>
                </div>
                <div class="col-md-12" (mouseover)="showpayment(true,'1')" (mouseout)="showpayment(false,'1')" id="1">
                    <div style="max-width: 100%; overflow: hidden; padding-bottom: 56.25%; position: relative;">

                        <iframe class="i-frame" src="https://www.youtube.com/embed/jitZ29MM6P0?si=5VFW-WvVm6ZI6KE_"
                            title="YouTube video player" frameborder="0"
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                            allowfullscreen></iframe>
                    </div>
                    <label for="" class="mt-4">The onboarding process refers to the steps and activities involved in
                        integrating and orienting merchants/customers into a product, or service. It is a critical phase
                        that sets the foundation for a positive and successful experience for the individuals involved.
                    </label>
                </div>

                <div class="col-md-12" (mouseover)="showpayment(true,'2')" (mouseout)="showpayment(false,'2')" id="2">
                    <h2 class="mt-4">The onboarding process of PayG</h2>
                    <label for="">PayG’s onboarding process is very simple and easy and includes only six steps. Here's
                        a general outline of the onboarding process of PayG: </label>


                    <h4 class="mt-4"><b>Step 1: Registration:</b></h4>
                    <label for="">Fill in all the mandatory details such as mobile number and legal business name and
                        then create a strong password and then click on the register button. </label>
                    <div class="row">
                        <div class="col-md-12 mt-3">
                            <img src="./assets/onboarding/Screenshot 2024-11-20 161917(1).png" width="100%"
                                height="100%" alt="">
                        </div>
                    </div>

                    <label for="" class="mt-4">Your account will be created successfully. </label>
                    <div class="row">
                        <div class="col-md-12 mt-3">
                            <img src="./assets/onboarding/A screenshot of a computer__Description automatically generated(2).png"
                                width="100%" height="100%" alt="">
                        </div>
                    </div>

                    <!-- <label for="" class="mt-4">The merchant can select GST if they have a GST number and fill in the
                        details.</label>
                    <div class="row">
                        <div class="col-md-12 mt-3">
                            <img src="./assets/o-3.png" width="100%" height="100%" alt="">
                        </div>
                    </div>

                    <label for="" class="mt-4">Add business owner details</label>
                    <div class="row">
                        <div class="col-md-12 mt-3">
                            <img src="./assets/o-4.png" width="100%" height="100%" alt="">
                        </div>
                    </div>
                    <label for="" class="mt-4">
                        The merchants need to add a short description of their business.
                    </label>
                    <div class="row">
                        <div class="col-md-12 mt-3">
                            <img src="./assets/o-5.png" width="100%" height="100%" alt="">
                        </div>
                        <div class="col-md-12 mt-3">
                            <img src="./assets/o-6.png" width="100%" height="100%" alt="">
                        </div>
                    </div> -->
                    <div class="row mt-4">
                        <h4><b>Step 2:Business Details:</b></h4>
                        <label for="" class="mt-4">
                            Merchants need to choose the type of account they need like professional, business,
                            government entity, or micro merchant. Then in the next step, PayG asks to fill out the
                            details as per the account type. </label>
                        <div class="row">
                            <div class="col-md-12 mt-3">
                                <img src="./assets/onboarding/image (3).png" width="100%" height="100%" alt="">
                            </div>
                        </div>

                        <label for="" class="mt-4">The merchants need to fill in their PAN or GST details.</label>
                        <div class="row">
                            <div class="col-md-12 mt-3">
                                <img src="./assets/onboarding/image (4).jpg" width="100%" height="100%" alt="">
                            </div>
                        </div>

                        <label for="" class="mt-4">Add your business owner details .</label>
                        <div class="row">
                            <div class="col-md-12 mt-3">
                                <img src="./assets/onboarding/image (5).png" width="100%" height="100%" alt="">
                            </div>
                        </div>

                        <label for="" class="mt-4">The merchants need to add a detailed description of their business and logo. </label>
                        <div class="row">
                            <div class="col-md-12 mt-3">
                                <img src="./assets/onboarding/image (5)(1).jpg" width="100%" height="100%" alt="img">
                            </div>
                        </div>

                        <label for="" class="mt-4">Next, select where you want to use our payment services </label>
                        <div class="row">
                            <div class="col-md-12 mt-3">
                                <img src="./assets/onboarding/image(6).png" width="100%" height="100%" alt="">
                            </div>
                        </div>

                    </div>

                    <div class="row mt-4">
                        <h4><b>Step 3: Bank Details:</b></h4>
                        <label for="" class="mt-4">
                            The merchant needs to add bank details like the account holder's name, IFSC code, and account number. </label>
                        <div class="row">
                            <div class="col-md-12 mt-3">
                                <img src="./assets/onboarding/image (7).png" width="100%" height="100%" alt="">
                            </div>
                        </div>
                    </div>

                    <div class="row mt-4">
                        <h4><b>Step 4: Business Overview:</b></h4>
                        <label for="" class="mt-4">
                            Search for your MCC code or your business category and move on to the next step.  </label>
                        <div class="row ">
                            <div class="col-md-12 mt-3">
                                <img src="./assets/onboarding/image (8).png" width="100%" height="100%" alt="">
                            </div>

                            <label for="" class="mt-4">
                                Tell us what kind of products and services you will be offering your customers.   </label>
                            <div class="col-md-12 mt-3">
                                <img src="./assets/onboarding/image (9).png" width="100%" height="100%" alt="">
                            </div>

                            <label for="" class="mt-4">
                                Select your yearly turn-over and per ticket average volume  </label>
                            <div class="col-md-12 mt-3">
                                <img src="./assets/onboarding/image (10).png" width="100%" height="100%" alt="">
                            </div>

                            <label for="" class="mt-4">
                                If you have an official website or app please provide the website or app link in this step  </label>
                            <div class="col-md-12 mt-3">
                                <img src="./assets/onboarding/image (11).jpg" width="100%" height="100%" alt="">
                            </div>

                            <label for="" class="mt-4">
                                If you have an official social media handle please provide the link in this step </label>
                            <div class="col-md-12 mt-3">
                                <img src="./assets/onboarding/image (12).png" width="100%" height="100%" alt="">
                            </div>
                        </div>
                    </div>

                    <div class="row mt-4">
                        <h4><b>Step 5: Document Verification:</b></h4>
                        <label for="" class="mt-4">
                            Upload all the documents so that our team can verify them. </label>
                        <div class="row">
                            <div class="col-md-12 mt-3">
                                <img src="./assets/onboarding/image (13).png" width="100%" height="100%" alt="">
                            </div>
                        </div>
                        <label for="" class="mt-4">
                            Your documents will be uploaded successfully </label>
                        <div class="row">
                            <div class="col-md-12 mt-3">
                                <img src="./assets/onboarding/image.jpg" width="100%" height="100%" alt="">
                            </div>
                        </div>
                    </div>


                    <div class="row mt-4">
                        <h4><b>Step 6: Agreement E-Sign:</b></h4>
                        <label for="" class="mt-4">
                            After successful testing and compliance checks, an agreement e-sign will be signed between PayG and the merchant and you will be onboarded successfully  </label>
                        <div class="row">
                            <!-- <div class="col-md-12 mt-3">
                                <img src="../../../assets/onboarding/image.jpg" width="100%" height="100%" alt="">
                            </div> -->
                            <!-- <label for="" class="mt-4">
                                You will be onboarded successfully </label> -->
                            <!-- <div class="col-md-12 mt-3">
                                <img src="./assets/o-15.png" width="100%" height="100%" alt="">
                            </div> -->
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="col-md-4  hide-tbl content2 ">
        <div class="card crd p-4">
            <div class="row">
                <div class="col-md-12">
                    <h5>
                        Table of Contents:
                    </h5>
                </div>

                <div class="col-md-12">
                    <a href="#1">
                        <div class="row">
                            <div class="col-md-2"> <img src="./assets/edit.svg" class="tab-icon intro" alt="">
                                &nbsp;</div>
                            <div class="col-md-10">
                                <span style="cursor: pointer;" class="textHover" [ngClass]="{'color':colors=='1'}"
                                    (click)="color('1')">
                                    What is an Onboarding process?</span>

                            </div>
                        </div>
                    </a>
                </div>
                <div class="col-md-12">
                    <a href="#2">
                        <div class="row">
                            <div class="col-md-2"> <img src="./assets/edit.svg" class="tab-icon intro" alt="">
                                &nbsp;</div>
                            <div class="col-md-10">
                                <span style="cursor: pointer;" class="textHover" [ngClass]="{'text':colors=='2'}"
                                    (click)="color('2')">Onboarding process of PayG
                                </span>
                            </div>
                        </div>
                    </a>
                </div>




            </div>
        </div>
    </div>
    <div class="col-md-9 hide ft-9">
        <hr>
        <div class=" row crd">
            <!-- <div class="col-md-8" style="width:70%">
                <a [routerLink]="['/pay-out']"> <button class="btn btn-color"> <img src="./assets/Arrow 3.svg"
                            alt="">&nbsp;&nbsp;Pay out
                    </button></a>

            </div> -->
            <div class="col-md-8" style="width:68%">
                <a [routerLink]="['/payment-gateway-working']"> <button class="btn btn-color"> <img src="./assets/Arrow 3.svg"
                            alt="">&nbsp;&nbsp;Payment gateway
                    </button></a>

            </div>

            <div class="col-md-4" style="width:32%">
                <a [routerLink]="['/merchant-dashboard']"> <button class="btn btn-color" (click)="menues('merchant')">
                        Merchant Dashboard
                        <img src="./assets/Arrow 2 1.svg" alt=""></button></a>

            </div>
        </div>
    </div>
</div>